import { useState, useEffect } from 'react';
import { API_URLS } from '../../../apiUrl';
import { Pagination } from '@mui/material';
import HoldingEdit from '../../../editModals/holdingEdit';
import axiosInstance from '../../../components/axiosInstance';

const HoldingNolist = ({ muniCipalityName, muniCipalityId }: any) => {
  const [holdingTableData, setHoldingTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [inputData, setInputData] = useState({ page: 1, limit: 50 });
  const [totalItems, setTotalItems] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [streetId, setStreetId] = useState("");
  const [holdingNo, setHoldingNo] = useState("");
  const [holdingType, setHoldingType] = useState("");
  const [nameOfComp, setNameOfComp] = useState("");
  const [coverArea, setCoverArea] = useState("");
  const [proeprtyLocation, setProeprtyLocation] = useState("");
  const [jlNo, setJLNo] = useState("");
  const [khatiyanNo, setKhatiyanNo] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [annualValuation, setAnnualValuation] = useState("");
  const [quaterlyTax, setQuaterlyTax] = useState("");
  const [mouzaName, setMouzaName] = useState("");
  const [propertyYear, setPropertyYear] = useState("");
  const [owner, setOwner] = useState("");
  const [calcAcr, setCalcAcr] = useState("");
  const [calcBigha, setCalcBigha] = useState("");
  const [calcKatha, setCalcKatha] = useState("");
  const [calcChatak, setCalcChatak] = useState("");
  const [calcSatak, setCalcSatak] = useState("");
  const [landSqft, setLandSqft] = useState("");
  const [holdingId, setHoldingId] = useState("");

  useEffect(() => {
    const fetchHolding = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axiosInstance.post(`${API_URLS.municipalityHoldingList}`, {
          municipalityTbl_id: muniCipalityId,
          page: inputData.page,
          limit: inputData.limit,
        });

        setHoldingTableData(response.data.data.data);
        setTotalItems(response.data.data.total);
      } catch (err) {
        setError('Something went wrong!');
      } finally {
        setLoading(false);
      }
    };

    fetchHolding();
  }, [inputData.page, muniCipalityId, inputData.limit]);

  const filteredData = holdingTableData.filter((item: any) =>
    item.holding_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.borough_name?.toLowerCase().includes(searchQuery.toLowerCase()) || 
    item.ward_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.street_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.holding_type?.toLowerCase().includes(searchQuery.toLowerCase()) 
  );

  const handlePageChange = (_event: any, value: number) => {
    setInputData((prevData) => ({
      ...prevData,
      page: value,
    }));
  };

  const totalPages = Math.ceil(totalItems / inputData.limit);

  const openModal = (holdingId: any, streetId: any, holdingNo: any, holdingType: any, nameOfComp: any, coverArea: any, proeprtyLocation: any, JLNo: any, khatiyanNo: any, fatherName: any, annualValuation: any, quaterlyTax: any, mouzaName: any, propertyYear: any, owner: any, calcAcr: any, calcBigha: any, calcKatha: any, calcChatak: any, calcSatak: any, landSqft: any) => {
    setHoldingId(holdingId);
    setStreetId(streetId);
    setHoldingNo(holdingNo);
    setHoldingType(holdingType);
    setNameOfComp(nameOfComp);
    setCoverArea(coverArea);
    setProeprtyLocation(proeprtyLocation);
    setJLNo(JLNo);
    setKhatiyanNo(khatiyanNo);
    setFatherName(fatherName);
    setAnnualValuation(annualValuation);
    setQuaterlyTax(quaterlyTax);
    setMouzaName(mouzaName);
    setPropertyYear(propertyYear);
    setOwner(owner);
    setCalcAcr(calcAcr);
    setCalcBigha(calcBigha);
    setCalcKatha(calcKatha);
    setCalcChatak(calcChatak);
    setCalcSatak(calcSatak);
    setLandSqft(landSqft);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="container mx-auto">
      <div className="flex gap-5 mb-4">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Holding No. List ({muniCipalityName})</h1>

        <div className="flex justify-end md:w-4/12 w-full ml-auto">
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
        <table className="min-w-full table-auto">
          <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
            <tr>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Borough</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Ward</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Street</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Holding No.</th>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Holding Type</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="py-3 px-6 text-center">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan={6} className="py-3 px-6 text-center text-red-500">{error}</td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={6} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
              </tr>
            ) : (
              filteredData.map((item: any, index) => (
                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.borough_name}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.ward_no}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.street_name}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.holding_no}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.holding_type}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600 text-center">
                    <div className="flex gap-2 justify-center">
                      <button 
                        onClick={() => openModal(
                          item.holding_primary_id, item.street_tbl_id, item.holding_no, 
                          item.holding_type, item.name_of_complex_apartment, item.cover_area, 
                          item.property_location, item.property_jl_no, item.property_khatiyan_no, 
                          item.property_owner_spouse_name_father_name, item.property_annual_valuation, 
                          item.property_quaterly_tax, item.holding_mouza_name, item.year_of_property, 
                          item.ownership, item.land_plot_area_calc_acar, item.land_plot_area_calc_bigha, 
                          item.land_plot_area_calc_katha, item.land_plot_area_calc_chatak, 
                          item.land_plot_area_calc_satak_decimal, item.land_sqft
                        )}
                        className="px-2 py-1.5 text-green-500 border border-green-200 rounded bg-green-100 hover:bg-green-200"
                      >
                        <i className="ri-edit-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {filteredData?.length > 0 && (
        <div className="flex justify-center mt-4">
          <Pagination
            count={totalPages}
            page={inputData.page}
            onChange={handlePageChange}
            color="primary"
          />
        </div>
      )}

      <HoldingEdit 
        isOpen={isModalOpen} 
        closeModal={closeModal} 
        muniCipalityName={muniCipalityName} 
        muniCipalityId={muniCipalityId} 
        holdingId={holdingId} 
        streetId={streetId} 
        holdingNo={holdingNo} 
        holdingType={holdingType} 
        nameOfComp={nameOfComp} 
        coverArea={coverArea} 
        proeprtyLocation={proeprtyLocation} 
        jlNo={jlNo} 
        khatiyanNo={khatiyanNo} 
        fatherName={fatherName} 
        annualValuation={annualValuation} 
        quaterlyTax={quaterlyTax} 
        mouzaName={mouzaName} 
        propertyYear={propertyYear} 
        owner={owner} 
        calcAcr={calcAcr} 
        calcBigha={calcBigha} 
        calcKatha={calcKatha} 
        calcChatak={calcChatak} 
        calcSatak={calcSatak} 
        landSqft={landSqft} 
      />
    </div>
  );
};

export default HoldingNolist;